import styled from '@emotion/styled/macro';
import { Link } from 'react-router-dom';

// eslint-disable-next-line import/prefer-default-export
export const StreaksContainer = styled(Link)`
    height: 27px;
    text-decoration: none;
`;
